import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Firebase, { METHODS } from "../Utils/Firebase";
import Social from "./SocialShare";
import LoaderModule from "./Loader";

import defaultAvatar from "../img/avatar.svg";
import edit from "../img/pencil.svg";
import clapLogo from "../img/clapping.svg";

const style = {
  card: {
    maxWidth: 345,
    margin: 5
  },
  avatar: {
    width: "20px",
    float: "left",
    border: "2px solid grey",
    borderRadius: "20px",
    padding: "2px",
    marginRight: "10px"
  },
  title: {
    fontSize: "1rem"
  },
  media: {
    objectFit: "cover",
    width: 345,
    height: 259,
    backgroundColor: "#222"
  },
  pitchTitle: {
    fontSize: "1.2rem",
    height: "50px",
    width: "90%",
    margin: "auto"
  },
  button: {
    fontSize: "2vh",
    letterSpacing: "2px",
    marginBottom: "10px",
    backgroundColor: "lightgrey",
    margin: "auto",
    textShadow: "1px 1px 1px gray"
  },
  clap: {
    marginLeft: "5px",
    fontSize: "2vh",
    verticalAlign: "super"
  },
  edit: {
    cursor: "pointer",
    opacity: ".6",
    float: "right",
    marginTop: "-475px",
    marginRight: "10px"
  },
  social: { marginLeft: "50px" }
};

class VideoCard extends Component {
  render() {
    const {
      videoId,
      classes,
      src,
      thumbnail,
      title,
      currentUser,
      userName,
      userAvatar,
      shareUrl,
      createdAt,
      onEvaluate,
      onCheck,
      isEvaluable,
      isShareable,
      isCheckable,
      onEditClick
    } = this.props;

    return (
      <div>
        <Card className={classes.card}>
          <CardContent>
            <img src={userAvatar ? userAvatar : defaultAvatar} style={style.avatar} alt='' />
            <Typography className={classes.title} align="left">
              {userName}
            </Typography>
          </CardContent>

          {
            thumbnail
            ? (
              <CardMedia
                component={"img"}
                className={classes.media}
                src={thumbnail}
                onClick={isShareable ? onEvaluate : null}
              />
            ) : (
              <CardMedia
                component={"video"}
                className={classes.media}
                src={src}
                onClick={isShareable ? onEvaluate : null}
              />
            )
          }

          <CardContent>
            <div style={{ float: "left" }}>
              <img src={clapLogo} alt="clap" />
              <Firebase
                refPath={`/videos/${videoId}/evaluations/`}
                method={METHODS.ON}
                renderSuccess={(snapshot) => {
                  return (
                    <span style={style.clap}>
                      {snapshot.val() ? snapshot.numChildren() : "0"}
                    </span>
                  );
                }}
                renderError={(error) => {
                  return <pre>{JSON.stringify(error)}</pre>;
                }}
                renderPending={() => <LoaderModule />}
              />
            </div>
            <Typography align="right" gutterBottom component="span">
              {createdAt}
            </Typography>

            <Typography
              variant="headline"
              component="h2"
              align="center"
              style={style.pitchTitle}
            >
              <div>{title}</div>
            </Typography>
          </CardContent>

          <CardActions>
            <Firebase
              refPath={`/videos/${videoId}/evaluations/`}
              method={METHODS.ON}
              renderSuccess={(snapshot) => {
                return isEvaluable && (
                  <Button
                    size="small"
                    color="primary"
                    onClick={onEvaluate}
                    style={style.button}
                  >
                    {
                      !snapshot.hasChild(currentUser) 
                        ? 'Voir & Evaluer' 
                        : 'Revoir'
                    }
                  </Button>
                )
              }}
              renderError={(error) => {
                return <pre>{JSON.stringify(error)}</pre>;
              }}
              renderPending={() => <LoaderModule /> }
            />

            {
              isCheckable && (
                <Firebase
                  refPath={`/videos/${videoId}/evaluations/`}
                  method={METHODS.ON}
                  renderSuccess={(snapshot) => {
                    return (
                      <span style={style.clap}>
                        <Button
                          size="small"
                          color="primary"
                          onClick={onCheck}
                          disabled={snapshot.val() ? false : true}
                          style={style.button}
                        >
                          Feedback
                        </Button>
                      </span>
                    );
                  }}
                  renderError={(error) => {
                    return <pre>{JSON.stringify(error)}</pre>;
                  }}
                  renderPending={() => <LoaderModule />}
                />
              )
            }

            {
              isShareable && (
                <div style={style.social}>
                  <Social shareUrl={shareUrl} title={title} />
                </div>
              )
            }
          </CardActions>
        </Card>
        {
          isCheckable && (
            <img
              src={edit}
              style={style.edit}
              alt="edit"
              width="35"
              onClick={onEditClick}
            />
          )
        }
      </div>
    );
  }
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  currentUser: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  owner: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  onEvaluate: PropTypes.func,
  onCheck: PropTypes.func,
  isShareable: PropTypes.bool,
  isEvaluable: PropTypes.bool,
  isCheckable: PropTypes.bool,
  onEditClick: PropTypes.func
};

VideoCard.defaultProps = {
  onEvaluate: () => {},
  onCheck: () => {},
  onEditClick: () => {},
  isShareable: false,
  isEvaluable: false,
  isCheckable: false
};

export default withStyles(style)(VideoCard);
